export const IT = 1;
export const EN = 2;
